import React, { useState } from "react";
import PropTypes from "prop-types";
import { setJwtToken } from "./utils/utils";

export const RootContext = React.createContext();

const RootContextProvider = ({ children }) => {
  const [user, setStateUser] = useState();
  const [account, setStateAccount] = useState();
  const [token, setStateToken] = useState();
  const [isTokenLoaded, setIsTokenLoaded] = useState();
  const [pages, setStatePages] = useState();
  const [listPages, setStateListPages] = useState();
  const [links, setStateLinks] = useState();

  const setToken = (newToken, shouldSave = false) => {
    if (shouldSave && newToken !== null) {
      window.localStorage.setItem("userToken", newToken);
      setIsTokenLoaded(true);
    } else if (shouldSave && newToken === null) {
      window.localStorage.clear();
    }
    setJwtToken(newToken);
    setStateToken(newToken);
    setIsTokenLoaded(true);
  };

  const setLinks = (state) => {
    setStateLinks(state);
  };

  const setPages = (state) => {
    setStatePages(state);
  };

  const setListPages = (state) => {
    setStateListPages(state);
  };

  const setAccount = (account) => {
    localStorage.setItem("account", JSON.stringify(account));
    setStateAccount(account);
  };

  const value = {
    user,
    setUser: setStateUser,
    account,
    setAccount,
    setStateAccount,
    token,
    setToken,
    isTokenLoaded,
    setIsTokenLoaded,
    pages,
    setPages,
    links,
    setLinks,
    setListPages,
    listPages,
  };
  return <RootContext.Provider value={value}>{children}</RootContext.Provider>;
};

RootContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default RootContextProvider;
